import React from 'react';
import { compose, keyBy, mapValues } from 'lodash/fp';

import { withStorage, WithStorageProps } from '@ihme/common/packages/storage';
import _ from '@ihme/common/locale';

import { AgeGroupEntity } from '../../models';

import ChartDropdown from '../ChartDropdown';
import api from '../../api';

type Props = React.ComponentProps<typeof ChartDropdown> & WithStorageProps & {
    refinedOptions: number[] | undefined;
};

type State = {
    order: AgeGroupEntity[] | null;
};

class AgeGroupsDropdown extends React.Component<Props, State> {
    state: State = {
        order: null
    };

    componentDidMount(): void {
        this.getOrder();
    }

    getOrder = () => {
        this.props.cached(api.getAgeGroups)()
            .then(ageGroups => {
                if (ageGroups) {
                    const order = compose(mapValues('order'), keyBy('id'))(ageGroups);
                    this.setState({ order });
                }
            })
            .catch(console.log);
    };

    sortAgeGroups = options => {
        const { order } = this.state;

        return options.sort(({ value: idA }, { value: idB }) => order[idA] - order[idB]);
    };

    disableOptions = (options, refinedOptions) => options.map(option => ({
        ...option,
        isDisabled: !(refinedOptions && refinedOptions.includes(option.value)),
    }));

    render() {
        const { refinedOptions } = this.props;
        const { order } = this.state;

        return (
            <ChartDropdown
                {...this.props}
                label={_('filter_age_group_title').toUpperCase()}
                filterKey="age_group_id"
                localePrefix="age_group_"
                preprocessOptions={options => {
                    const sortedOptions = order ? this.sortAgeGroups(options) : [];
                    return refinedOptions ? this.disableOptions(sortedOptions, refinedOptions): sortedOptions;
                }}
            />
        );
    }
}

export default withStorage(AgeGroupsDropdown);
